import React, { useEffect, useState } from 'react';
import GreetingHeader from '../../shared/GreetingHeader';
import LoadingDots from '../../shared/LoadingDots';
import { useSelector, useDispatch } from 'react-redux';
import { selectLabTests, fetchAllLabTests,selectLabTestsLoading } from '../../../ReduxSlices/LabTests/labTestSlice';


const LabTechDashboard = ({ user, navigateTo }) => {
   const dispatch = useDispatch();
  
   const labTests = useSelector(selectLabTests).filter(
    (test) => test.status === 'pending'
    );

   const completedTests = useSelector(selectLabTests).filter(
      (test) => test.status === 'completed'
    );

   const todayStr = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
   const completedTodayCount = completedTests.filter((test) => {
      const completedDate = new Date(test.updated_at).toISOString().slice(0, 10);
      return completedDate === todayStr;
    }).length;

   const pendingCount = labTests.length;

   const loading = useSelector(selectLabTestsLoading);

    useEffect(() => {
      dispatch(fetchAllLabTests());
    }, [dispatch]);
 

  return (
    <div className="p-6">

      <GreetingHeader name={user?.name} />

      <div className="labdashboard grid grid-cols-4 sm:grid-cols-2 gap-6">
        {/* Pending Tests Card */}
        <div className="pending items-center col-span-2 col-start-1 bg-white border rounded-xl shadow-md p-6">
          <div className='quick-actions'>
          <h3 className="text-lg font-semibold mb-2">Pending Lab Tests</h3>
            <button
            type="button"
            onClick={() => navigateTo('tests')}
            className="bg-green-600 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded-lg shadow"
              >
            📋 View pending tests
          </button>
          </div>
          {loading ? (
            <LoadingDots height={10} width={30} color="#38AD3E" />
          ) : (          
            <p className="text-3xl font-bold text-blue-600">
              <strong>{pendingCount}</strong>
            </p>        
             )}
        </div>

        {/* Completed Today Card */}
        <div className="pending items-center col-span-2 col-start-3 bg-white border rounded-xl shadow-md p-6">
          <h3 className="text-lg font-semibold mb-2">Tests Completed Today</h3>
          {loading ? (
            <LoadingDots height={10} width={30} color="#38AD3E" />
          ) : (
            <p className="text-3xl font-bold text-green-600">
              <strong>{completedTodayCount}</strong>
            </p>
          )}
        </div>

        {/* Lab Supplies Card */}
        <div className="pending items-center col-span-2 col-start-1 bg-white border rounded-xl shadow-md p-6">
          <div className="quick-actions">
            <h3 className="text-lg font-semibold mb-2">Lab Supplies</h3>
            <button
              type="button"
              onClick={() => navigateTo('lab_supplies_list')}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded-lg shadow"
            >
              📦 Manage supplies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LabTechDashboard;